<template>
  <div class="w-full h-full flex flex-col">
    <v-select
      :options="reportData"
      placeholder="Select Asset"
      v-model="selectedArr"
      :clearable="false"
      value="arr"
      label="assetName"
    >
    </v-select>
    <div class="w-full h-full flex justify-center items-center" ref="wrapper">
      <vue-apex-charts
        v-if="height"
        :width="width"
        :height="height"
        type="donut"
        :options="chartOptions"
        :series="chartData"
      />
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import vSelect from 'vue-select';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
momentDurationFormatSetup(moment);
export default {
  components: { VueApexCharts, vSelect },
  props: {
    reportData: {},
    summarySeries: Array,
    currentTable: Array,
    type: String,
    activeTab: Number,
    gridId: { default: '' },
    timeRange: {},
    reportsComponent: {},
  },
  data() {
    return {
      width: '100',
      height: null,
      selectedArr: '',
      chartData: [],
      chartOptions: {
        chart: {
          id: 'Summary-PieChart',
          toolbar: {
            show: true,
          },
          height: 100,
        },
        tooltip: {
          enabled: false,
        },
        dataLabels: {
          style: {
            fontSize: '14px',
            // fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 'bold',
            colors: ['#000000'],
          },
          background: {
            enabled: true,
            foreColor: '#fff',
            borderRadius: 4,
            padding: 10,
            opacity: 0.9,
            borderWidth: 1,
            borderColor: '#fff',
            dropShadow: {
              enabled: true,
              top: 3,
              left: 3,
              blur: 5,
              color: '#000',
              opacity: 0.25,
            },
          },
          enabled: true,
          formatter: function (val, opts) {
            var duration = moment.duration(
              opts.w.config.series[opts.seriesIndex],
              'seconds',
            );
            // console.log(new Date(5965000));
            var formattedDuration = duration.format('hh:mm:ss', {
              trim: false,
            });
            return val.toFixed(1) + '% (' + formattedDuration + ')';
          },
        },
        labels: ['Moving', 'Idling', 'Parked'],
        // colors: ['#28C76F', '#FFFF00', '#EA5455'],

        colors: ['#00E496', '#FFB01A', '#FF4560'],
        responsive: [
          {
            // breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      },
    };
  },
  watch: {
    selectedArr: {
      handler(val) {
        if (val) {
          this.chartData = val.arr;
          this.chartData.forEach((e, i) => {
            if (!e) {
              this.chartData[i] = 0;
            }
          });
        }
      },
      immediate: true,
    },
    reportData: {
      handler() {
        this.selectedArr = this.reportData.at(-1);
      },
      immediate: true,
    },
  },
  methods: {
    getChart(args) {
      var self = this;

      self.isLoading = true;

      self.$http
        .post('reports-utils/getIndividualSummaryBreakdown', {
          timeRange: self.timeRange,
          uid: self.userInfo.uid,
          configuration: self.configuration,
          unitId: args.unitId,
          assetId: args.assetId,
          assetName: args.assetName,
          type: 'Chart',
          geoPOIData: self.geoPOIData,
        })
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.breakdownData.push({
              assetId: args.assetId,
              type: 'Chart',
              assetName: args.assetName,
              arr: response.data.summarySeries,
            });
            console.log(self.breakdownData);

            self.forceRender += 1;
            self.activeTab = self.breakdownData.length + 5;
            self.isLoading = false;
          } else {
            self.isLoading = false;
            if (response.data.error) {
              self.$vs.notify({
                title: 'Error',
                text: 'Try again later.',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
              });
            } else {
              self.$vs.notify({
                title: 'Error',
                text: 'Try again later.',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
              });
            }
          }
        })
        .catch(function (error) {
          console.log(error);
          self.isLoading = false;

          self.$vs.notify({
            title: 'Error',
            text: 'Try again later.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        let wrapper = this.$refs.wrapper.getBoundingClientRect();
        this.width = wrapper.width;
        this.height = (wrapper.height * 80) / 100;
        if(this.type=='POI - Watch'){
          this.chartOptions = {
        chart: {
          id: 'POI-Watch-PieChart',
          toolbar: {
            show: true,
          },
          height: 100,
        },
        tooltip: {
          enabled: false,
        },
        dataLabels: {
          style: {
            fontSize: '14px',
            // fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 'bold',
            colors: ['#000000'],
          },
          background: {
            enabled: true,
            foreColor: '#fff',
            borderRadius: 4,
            padding: 10,
            opacity: 0.9,
            borderWidth: 1,
            borderColor: '#fff',
            dropShadow: {
              enabled: true,
              top: 3,
              left: 3,
              blur: 5,
              color: '#000',
              opacity: 0.25,
            },
          },
          enabled: true,
          formatter: function (val, opts) {
            var duration = moment.duration(
              opts.w.config.series[opts.seriesIndex],
              'seconds',
            );
            // console.log(new Date(5965000));
            var formattedDuration = duration.format('hh:mm:ss', {
              trim: false,
            });
            return val.toFixed(1) + '% (' + formattedDuration + ')';
          },
        },
        labels: ['Productive', 'Non-Productive', 'Others'],
        // colors: ['#28C76F', '#FFFF00', '#EA5455'],
        colors: ['#00E496', '#FF4560', '#FFB01A'],
        responsive: [
          {
            // breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      };
        }
      }, 100);
    });
  },
};
</script>

<style>
/* .apexcharts-pie {
  transform: scale(0.8);
} */
</style>
